export default "__VITE_ASSET__4dde6665__"